// ═══════════════════════════════════════════════════
// VIDEO PRODUCT CATALOG — Complete pricing tables
// ═══════════════════════════════════════════════════

// 1. Culling Only
export const CULLING_PRODUCT = {
  id: 'culling-only', name: 'Culling Only', price: 349, product_type: 'video',
  turnaround_days: 3, editor_pay: 0, is_doc_edit: false,
  nle_options: ['Adobe Premiere', 'DaVinci Resolve', 'Final Cut Pro'],
};

// 2. Social Media Video
export const SOCIAL_MEDIA_PRODUCTS = [
  { id: 'sm-60s', name: 'Social Media Video', duration: '60 Seconds', duration_minutes: 1, price: 249, turnaround_days: 1, editor_pay: 60, is_doc_edit: false },
  { id: 'sm-90s', name: 'Social Media Video', duration: '90 Seconds', duration_minutes: 1.5, price: 349, turnaround_days: 1, editor_pay: 80, is_doc_edit: false },
];

// 3. Highlight Video — Music Only (2–10 minutes, per-minute pricing)
export const HIGHLIGHT_MUSIC_ONLY = [
  { minutes: 2, price: 399, editor_pay: 90, turnaround_days: 3 },
  { minutes: 3, price: 449, editor_pay: 105, turnaround_days: 3 },
  { minutes: 4, price: 499, editor_pay: 120, turnaround_days: 3 },
  { minutes: 5, price: 549, editor_pay: 135, turnaround_days: 3 },
  { minutes: 6, price: 599, editor_pay: 150, turnaround_days: 3 },
  { minutes: 7, price: 649, editor_pay: 165, turnaround_days: 4 },
  { minutes: 8, price: 699, editor_pay: 180, turnaround_days: 4 },
  { minutes: 9, price: 749, editor_pay: 195, turnaround_days: 4 },
  { minutes: 10, price: 799, editor_pay: 210, turnaround_days: 4 },
];

// 4. Highlight Video — Music + Dialogue (3–25 minutes, per-minute pricing)
export const HIGHLIGHT_MUSIC_DIALOGUE = [
  { minutes: 3, price: 599, editor_pay: 165, turnaround_days: 4 },
  { minutes: 4, price: 622, editor_pay: 177, turnaround_days: 5 },
  { minutes: 5, price: 646, editor_pay: 188, turnaround_days: 6 },
  { minutes: 6, price: 669, editor_pay: 200, turnaround_days: 6 },
  { minutes: 7, price: 692, editor_pay: 217, turnaround_days: 7 },
  { minutes: 8, price: 716, editor_pay: 233, turnaround_days: 8 },
  { minutes: 9, price: 739, editor_pay: 250, turnaround_days: 8 },
  { minutes: 10, price: 754, editor_pay: 262, turnaround_days: 9 },
  { minutes: 11, price: 769, editor_pay: 275, turnaround_days: 9 },
  { minutes: 12, price: 784, editor_pay: 288, turnaround_days: 10 },
  { minutes: 13, price: 799, editor_pay: 300, turnaround_days: 10 },
  { minutes: 14, price: 826, editor_pay: 333, turnaround_days: 11 },
  { minutes: 15, price: 852, editor_pay: 367, turnaround_days: 12 },
  { minutes: 16, price: 879, editor_pay: 400, turnaround_days: 12 },
  { minutes: 17, price: 901, editor_pay: 420, turnaround_days: 13 },
  { minutes: 18, price: 923, editor_pay: 440, turnaround_days: 13 },
  { minutes: 19, price: 945, editor_pay: 460, turnaround_days: 14 },
  { minutes: 20, price: 967, editor_pay: 480, turnaround_days: 14 },
  { minutes: 21, price: 989, editor_pay: 500, turnaround_days: 14 },
  { minutes: 22, price: 1011, editor_pay: 520, turnaround_days: 15 },
  { minutes: 23, price: 1033, editor_pay: 540, turnaround_days: 15 },
  { minutes: 24, price: 1055, editor_pay: 560, turnaround_days: 16 },
  { minutes: 25, price: 1077, editor_pay: 580, turnaround_days: 16 },
];

// 5. Doc Edits (all is_doc_edit: true — routes to client's doc editor)
export const DOC_EDIT_PRODUCTS = [
  { id: 'doc-cer-rec', name: 'Ceremony + Reception Doc Edit', price: 149, editor_pay: 0, turnaround_days: 2, is_doc_edit: true },
  { id: 'doc-cer', name: 'Ceremony Doc Edit', price: 99, editor_pay: 0, turnaround_days: 2, is_doc_edit: true },
  { id: 'doc-rec', name: 'Reception Doc Edit', price: 99, editor_pay: 0, turnaround_days: 2, is_doc_edit: true },
  { id: 'doc-full', name: 'Full Day Doc Edit', price: 249, editor_pay: 0, turnaround_days: 2, is_doc_edit: true },
  { id: 'doc-speeches', name: 'Speeches Only', price: 75, editor_pay: 0, turnaround_days: 2, is_doc_edit: true },
  { id: 'doc-dances', name: 'Dances Only', price: 75, editor_pay: 0, turnaround_days: 2, is_doc_edit: true },
];

// ═══════════════════════════════════════════════════
// PHOTO PRODUCT CATALOG — Unchanged
// ═══════════════════════════════════════════════════
export const PHOTO_PRICING = {
  bundle: { name: 'Photo Edit Bundle', description: 'Up to 700 edited images', price: 175, cap: 700 },
  overage_per_image: 0.25,
  culling_per_image: 0.06,
  retouch_per_image: 2.50,
};

// ═══════════════════════════════════════════════════
// SHARED OPTIONS
// ═══════════════════════════════════════════════════
export const FOOTAGE_TRANSFER_OPTIONS = ['Cloud Upload (Dropbox/Drive/WeTransfer)', 'Hard Drive', 'Other'];
export const FOOTAGE_STATUS_OPTIONS = ['Upload complete', 'Still uploading', 'Not started'];
export const EVENT_DAYS_OPTIONS = ['1', '1.5', '2', '2.5', '3', '3.5', '4', '4.5', '5', '5.5', '6', '6.5', '7'];
// What kind of event (Ryan, 2026-10-09: "clients should choose it on the order form definitely"): the order's wedding
// type, which the prep reads (backend app/autoprep_queue/rules.WEDDING_TYPES; admin and staff can change it on the
// project's card). The client's words here; the stored values are the portal's.
export const EVENT_TYPE_OPTIONS = [
  ['standard', 'Wedding'], ['jewish', 'Jewish wedding'], ['indian', 'Indian / Hindu wedding'], ['sikh', 'Sikh wedding'],
  ['muslim', 'Muslim wedding'], ['mitzvah', 'Bar / Bat Mitzvah'],
];
export const LANGUAGE_OPTIONS = ['English', 'Spanish', 'French', 'Portuguese', 'Italian', 'German', 'Mandarin Chinese', 'Japanese', 'Korean', 'Hindi', 'Arabic', 'Hebrew', 'Russian', 'Polish', 'Dutch', 'Greek', 'Turkish', 'Swedish', 'Norwegian', 'Danish', 'Finnish', 'Czech', 'Hungarian', 'Romanian', 'Croatian', 'Thai', 'Vietnamese', 'Tagalog (Filipino)', 'Indonesian', 'Farsi (Persian)'];
export const NLE_OPTIONS = ['Adobe Premiere', 'DaVinci Resolve', 'Final Cut Pro'];

// Legacy — keep for backward compat with old VIDEO_CATEGORIES references
export const VIDEO_CATEGORIES = [];
